import { createApi } from '@reduxjs/toolkit/query/react'
import type {
	CheckUsernameApiResponse,
	ForgotPasswordApiResponse,
	ForgotPasswordRequest,
	GoogleLoginRequest,
	LoginApiResponse,
	LoginRequest,
	MetaMaskLoginRequest,
	MetaMaskNonceResponse,
	RegisterApiResponse,
	RegisterRequest,
	RevokeTokenApiResponse,
	SetUsernameApiResponse,
	SetUsernameRequest,
} from '@/types/auth'
import { playerBaseQuery } from './playerBaseQuery'

export const authApi = createApi({
	reducerPath: 'authApi',
	baseQuery: playerBaseQuery,
	endpoints: (builder) => ({
		login: builder.mutation<LoginApiResponse, LoginRequest>({
			query: (body) => ({
				url: '/auth/login',
				method: 'POST',
				body,
			}),
		}),
		googleLogin: builder.mutation<LoginApiResponse, GoogleLoginRequest>({
			query: (body) => ({
				url: '/auth/google',
				method: 'POST',
				body,
			}),
		}),
		getMetaMaskNonce: builder.mutation<MetaMaskNonceResponse, string>({
			query: (address) => ({
				url: '/auth/metamask/nonce',
				method: 'GET',
				params: { address },
			}),
		}),
		metaMaskLogin: builder.mutation<LoginApiResponse, MetaMaskLoginRequest>({
			query: (body) => ({
				url: '/auth/metamask',
				method: 'POST',
				body,
			}),
		}),
		setUsername: builder.mutation<SetUsernameApiResponse, SetUsernameRequest>({
			query: (body) => ({
				url: '/auth/set-username',
				method: 'POST',
				body,
			}),
		}),
		register: builder.mutation<RegisterApiResponse, RegisterRequest>({
			query: (body) => ({
				url: '/auth/register',
				method: 'POST',
				body,
			}),
		}),
		forgotPassword: builder.mutation<ForgotPasswordApiResponse, ForgotPasswordRequest>({
			query: (body) => ({
				url: '/auth/forgot-password',
				method: 'POST',
				body,
			}),
		}),
		checkUsername: builder.query<CheckUsernameApiResponse, string>({
			query: (username) => ({
				url: '/auth/check-username',
				params: { username },
			}),
		}),
		revokeToken: builder.mutation<RevokeTokenApiResponse, void>({
			query: () => ({
				url: '/auth/revoke-token',
				method: 'DELETE',
			}),
		}),
	}),
})

export const {
	useLoginMutation,
	useGoogleLoginMutation,
	useGetMetaMaskNonceMutation,
	useMetaMaskLoginMutation,
	useSetUsernameMutation,
	useRegisterMutation,
	useForgotPasswordMutation,
	useCheckUsernameQuery,
	useRevokeTokenMutation,
} = authApi
